import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import { AxiosApi } from "../../helpers/AxiosApi";
import initialStates from "./state";

// Get Products List
export const getProductList = createAsyncThunk(
  "getProductList",
  async (
    {
      search,
      pageLimit,
      pageCount,
      category_id,
      sort_by,
      sort_direction,
      outlet_id,
    },
    { rejectWithValue }
  ) => {
    const outletQuery =
      outlet_id && outlet_id.length > 0 ? JSON.stringify(outlet_id) : "";
    try {
      const response = await AxiosApi.get(
        `products?search=${search}&category_id=${
          category_id ?? ""
        }&page=${pageCount}&limit=${pageLimit}&sort_by=${sort_by}&sort_direction=${sort_direction}&outlet_id=${outletQuery}`
      );
      return response.data;
    } catch (error) {
      if (!error) {
        throw error.response;
      }
      toast.error(error.response.data.message);
      return rejectWithValue(error.response.data);
    }
  }
);

// Get Product
export const getProduct = createAsyncThunk(
  "getProduct",
  async (id, { rejectWithValue }) => {
    try {
      const response = await AxiosApi.get(`/products/${id}`);
      return response.data;
    } catch (error) {
      if (!error) {
        throw error.response;
      }
      toast.error(error.response.data.message);
      return rejectWithValue(error.response.data);
    }
  }
);

// Create Edit Products
export const createProduct = createAsyncThunk(
  "createProduct",
  async (data, { rejectWithValue }) => {
    try {
      const response = await AxiosApi.post(`products`, data);
      toast.success(response.data.message);
      return response.data;
    } catch (error) {
      if (!error) {
        throw error.response;
      }
      toast.error(error.response.data.message);
      return rejectWithValue(error.response.data);
    }
  }
);

// update Product Status
export const updateProductStatus = createAsyncThunk(
  "updateProductStatus",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const response = await AxiosApi.put(`products/${id}`, data);
      toast.success(response.data.message);
      return response.data;
    } catch (error) {
      if (!error) {
        throw error.response;
      }
      toast.error(error.response.data.message);
      return rejectWithValue(error.response.data);
    }
  }
);

// Delete Product
export const deleteProduct = createAsyncThunk(
  "deleteProduct",
  async (id, { rejectWithValue }) => {
    try {
      const response = await AxiosApi.delete(`/products/${id}`);
      toast.success(response.data.message);
      return response.data;
    } catch (error) {
      if (!error) {
        throw error.response;
      }
      toast.error(error.response.data.message);
      return rejectWithValue(error.response.data);
    }
  }
);

// Upload Product Image
export const uploadImage = createAsyncThunk(
  "uploadImage",
  async (data, { rejectWithValue }) => {
    try {
      const response = await AxiosApi.post(`upload`, data);
      toast.success(response.data.msg);
      return response.data;
    } catch (error) {
      if (!error) {
        throw error.response;
      }
      toast.error(error.response.data.message);
      return rejectWithValue(error.response.data);
    }
  }
);

// Get Product Interest
export const getProductInterestList = createAsyncThunk(
  "getProductInterestList",
  async (
    {
      search,
      pageLimit,
      pageCount,
      category_id,
      sort_by,
      sort_direction,
      status,
      sales_person,
    },
    { rejectWithValue }
  ) => {
    try {
      const response = await AxiosApi.get(
        `product-interset?search=${search}&categories_ids=${
          category_id ?? ""
        }&page=${pageCount}&limit=${pageLimit}&sort_by=${sort_by}&sort_direction=${sort_direction}&status=${status}&sales_person=${sales_person}`
      );
      return response.data;
    } catch (error) {
      if (!error) {
        throw error.response;
      }
      toast.error(error.response.data.message);
      return rejectWithValue(error.response.data);
    }
  }
);

// update Product Interest
export const updateProductInterest = createAsyncThunk(
  "updateProductInterest",
  async ({ id, data }, { rejectWithValue }) => {
    console.log("id, data : ", id, data);
    try {
      const response = await AxiosApi.put(`product-interset/${id}`, data);
      toast.success(response.data.message);
      return response.data;
    } catch (error) {
      if (!error) {
        throw error.response;
      }
      toast.error(error.response.data.message);
      return rejectWithValue(error.response.data);
    }
  }
);

// Delete Product Interest
export const deleteProductInterest = createAsyncThunk(
  "deleteProductInterest",
  async (id, { rejectWithValue }) => {
    try {
      const response = await AxiosApi.delete(`product-interset/${id}`);
      toast.success(response.data.message);
      return response.data;
    } catch (error) {
      if (!error) {
        throw error.response;
      }
      toast.error(error.response.data.message);
      return rejectWithValue(error.response.data);
    }
  }
);

const productsSlice = createSlice({
  name: "products",
  initialState: initialStates,
  extraReducers: (builder) => {
    builder
      // get Products List
      .addCase(getProductList.pending, (state) => {
        state.loading = true;
      })
      .addCase(getProductList.fulfilled, (state, action) => {
        state.loading = false;
        state.getProductListStatus.data = action.payload;
        state.error = false;
      })
      .addCase(getProductList.rejected, (state) => {
        state.loading = false;
        state.error = true;
      })
      // Get Product
      .addCase(getProduct.pending, (state) => {
        state.loading = true;
      })
      .addCase(getProduct.fulfilled, (state, action) => {
        state.loading = false;
        state.getProductStatus.data = action.payload;
        state.error = false;
      })
      .addCase(getProduct.rejected, (state) => {
        state.loading = false;
        state.error = true;
      })
      // Create Edit products
      .addCase(createProduct.pending, (state) => {
        state.loading = true;
      })
      .addCase(createProduct.fulfilled, (state, action) => {
        state.loading = false;
        state.createProductStatus.data = action.payload;
        state.error = false;
      })
      .addCase(createProduct.rejected, (state) => {
        state.loading = false;
        state.error = true;
      })
      // update Product Status
      .addCase(updateProductStatus.pending, (state) => {
        state.loading = true;
      })
      .addCase(updateProductStatus.fulfilled, (state, action) => {
        state.loading = false;
        state.updateProductStatusStatus.data = action.payload;
        state.error = false;
      })
      .addCase(updateProductStatus.rejected, (state) => {
        state.loading = false;
        state.error = true;
      })
      // Delete Product
      .addCase(deleteProduct.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteProduct.fulfilled, (state, action) => {
        state.loading = false;
        state.deleteProductStatus.data = action.payload;
        state.error = false;
      })
      .addCase(deleteProduct.rejected, (state) => {
        state.loading = false;
        state.error = true;
      })
      // Upload Product Image
      .addCase(uploadImage.pending, (state) => {
        state.loading = true;
      })
      .addCase(uploadImage.fulfilled, (state, action) => {
        state.loading = false;
        state.uploadImageStatus.data = action.payload;
        state.error = false;
      })
      .addCase(uploadImage.rejected, (state) => {
        state.loading = false;
        state.error = true;
      })
      // get Product InterestList
      .addCase(getProductInterestList.pending, (state) => {
        state.loading = true;
      })
      .addCase(getProductInterestList.fulfilled, (state, action) => {
        state.loading = false;
        state.getProductInterestListStatus.data = action.payload;
        state.error = false;
      })
      .addCase(getProductInterestList.rejected, (state) => {
        state.loading = false;
        state.error = true;
      });
  },
});
const { reducer } = productsSlice;
export default reducer;
